import { render, staticRenderFns } from "./BaseWordMenu.vue?vue&type=template&id=37f85e5a&"
import script from "./BaseWordMenu.vue?vue&type=script&lang=js&"
export * from "./BaseWordMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/www/word-trainer-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VList,VListTile,VListTileTitle,VMenu})
